import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';

const BlogListOne = () => {
    const blogPosts = [
        {
            id: 1,
            title: "The Future of Design Systems",
            excerpt: "Exploring how design systems are revolutionizing the way we create digital experiences and streamline product development.",
            image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        },
        {
            id: 2,
            title: "Mastering React Performance",
            excerpt: "Deep dive into advanced techniques for optimizing React applications and improving overall user experience.",
            image: "/images/testimonial/testimonial-3.jpg"
        }
    ];

    return (
        <div className="container py-5">
            <div className="row">
                {blogPosts.map((post) => (
                    <div key={post.id} className="col-md-6 mb-4">
                        <div className="card h-100 shadow-sm border-0 transform-on-hover">
                            <div className="card-img-top overflow-hidden">
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="img-fluid w-100"
                                    style={{
                                        height: '250px',
                                        objectFit: 'cover',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                            </div>

                            <div className="card-body">
                                <h5 className="card-title mb-3">
                                    <Link
                                        to={`/login`}
                                        className="text-decoration-none text-dark"
                                    >
                                        {post.title}
                                    </Link>
                                </h5>

                                <p className="card-text text-muted mb-4">
                                    {post.excerpt}
                                </p>

                                <Link
                                    to={`/login`}
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-between"
                                >
                                    <span>Read More</span>
                                    <ArrowRight size={20} />
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <style>{`
        .transform-on-hover {
          transition: transform 0.3s ease;
        }
        .transform-on-hover:hover {
          transform: scale(1.03);
          box-shadow: 0 10px 20px rgba(0,0,0,0.12) !important;
        }
        .card-img-top img:hover {
          transform: scale(1.1);
        }
      `}</style>
        </div>
    );
};

export default BlogListOne;